module.exports = __webpack_public_path__ + "static/img/female-bg-pt.977594d3.png";